import React from 'react';

import { Tool, ToolHeader } from '@modernloop/ai-elements';
import { useTranslation } from '@modernloop/i18n';

import { AGENT_TOOL_STATUS, type AgentToolStatus } from '../agent/chatItems';
import { toElementTool } from '../agent/toElements';
import type { AGENT_TRANSCRIPT_SEGMENT, AgentTranscriptSegment } from '../agent/transcriptSegments';

export type ToolActivitySegment = Extract<
  AgentTranscriptSegment,
  { type: typeof AGENT_TRANSCRIPT_SEGMENT.TOOL_ACTIVITY }
>;

const toolStatusMessageKey = (status: AgentToolStatus) => {
  switch (status) {
    case AGENT_TOOL_STATUS.RUNNING:
      return 'hiring-dashboard-ai-assistant:agent.tool.running';
    case AGENT_TOOL_STATUS.SUCCEEDED:
      return 'hiring-dashboard-ai-assistant:agent.tool.succeeded';
    case AGENT_TOOL_STATUS.FAILED:
      return 'hiring-dashboard-ai-assistant:agent.tool.failed';
  }
};

type Props = {
  segment: ToolActivitySegment;
};

/** One tool-activity row of the transcript, rendered as a non-expandable AI Elements tool header. */
const ToolActivityPart: React.FC<Props> = ({ segment }) => {
  const { t } = useTranslation();
  return (
    <Tool>
      <ToolHeader
        expandable={false}
        statusLabel={t(toolStatusMessageKey(segment.status), { toolName: segment.toolName })}
        title={segment.toolName}
        {...toElementTool(segment)}
      />
    </Tool>
  );
};

export default ToolActivityPart;
